'use client';

import { useLocale, useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { formatLocalizedRelativeTime } from '../lib/dateTime';

export const useRelativeTime = () => {
  const t = useTranslations('common.timeAgo');
  const locale = useLocale();

  return useCallback(
    (value: string | Date): string => {
      return formatLocalizedRelativeTime(value, locale, {
        justNow: t('justNow'),
        fallback: '',
      });
    },
    [locale, t],
  );
};
